export enum IncomingAchColumns {
	id = "Id",
	account = "Account",
	customer = "Customer",
	bank = "Bank",
	org = "Org",
	amount = "Amount",
	status = "Status",
	createdAt = "Created At",
}

export type AllowedIncomingAchColumns =
	| IncomingAchColumns.id
	| IncomingAchColumns.account
	| IncomingAchColumns.customer
	| IncomingAchColumns.bank
	| IncomingAchColumns.org
	| IncomingAchColumns.amount
	| IncomingAchColumns.status
	| IncomingAchColumns.createdAt
